// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-container {
  position: relative;
  display: inline-block;
  margin-left: 6px;
}

.info-icon {
  color: var(--azul-destaque);
  cursor: pointer;
  font-size: 16px;
}

.tooltip-box {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  margin-top: 4px;
  background-color: #333;
  color: #fff !important;
  padding: 8px 10px;
  border-radius: 4px;
  white-space: normal;
  width: max-content;
  max-width: 240px;
  font-size: 13px;
  line-height: 1.4;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}


.tooltip-top {
  bottom: 100%;
  top: auto;
  left: 0;
  margin-bottom: 4px;
  margin-top: 0;
}

.tooltip-bottom {
  top: 100%;
  bottom: auto;
  left: 0;
  margin-top: 4px;
  margin-bottom: 0;
}

.tooltip-right {
  top: 50%;
  left: 120%;
  transform: translateY(-50%);
}

.tooltip-left {
  top: 50%;
  right: 120%;
  left: auto;
  transform: translateY(-50%);
}`, "",{"version":3,"sources":["webpack://./src/components/TooltipInfo/tooltipInfo.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;;AAGA;EACE,YAAY;EACZ,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,UAAU;EACV,2BAA2B;AAC7B","sourcesContent":[".tooltip-container {\n  position: relative;\n  display: inline-block;\n  margin-left: 6px;\n}\n\n.info-icon {\n  color: var(--azul-destaque);\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.tooltip-box {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  margin-top: 4px;\n  background-color: #333;\n  color: #fff !important;\n  padding: 8px 10px;\n  border-radius: 4px;\n  white-space: normal;\n  width: max-content;\n  max-width: 240px;\n  font-size: 13px;\n  line-height: 1.4;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.2);\n}\n\n\n.tooltip-top {\n  bottom: 100%;\n  top: auto;\n  left: 0;\n  margin-bottom: 4px;\n  margin-top: 0;\n}\n\n.tooltip-bottom {\n  top: 100%;\n  bottom: auto;\n  left: 0;\n  margin-top: 4px;\n  margin-bottom: 0;\n}\n\n.tooltip-right {\n  top: 50%;\n  left: 120%;\n  transform: translateY(-50%);\n}\n\n.tooltip-left {\n  top: 50%;\n  right: 120%;\n  left: auto;\n  transform: translateY(-50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
